import React from "react";
import { Tooltip } from "@mui/material";

// "Tiny Language Models - How to..." -> "Tiny Language Mod..."
function truncateTitle(title = "", max = 18) {
  if (!title) return "";
  return title.length <= max ? title : `${title.slice(0, max).trimEnd()}...`;
}

const YoutubeLink = ({ youtubeLinks = [], setYoutubeLinks }) => {
  const handleRemove = (uuid) => {
    setYoutubeLinks((prev) => prev.filter((l) => l?.uuid !== uuid));
  };

  return (
    <>
      {youtubeLinks.length > 0 &&
        youtubeLinks.map((link, index) => {
          const openUrl = link?.s3_url || link?.rawUrl || link?.embedUrl;
          const title = link?.video_title || "YouTube link";
          const id = link?.uuid || `yt-${index}`;

          return (
            <Tooltip
              key={id}
              title={title}
              placement="top"
              arrow
              slotProps={{
                tooltip: { sx: { fontSize: "14px" } },
              }}
            >
              <div
                className="pdf_box_sec_inner_single youtube_link_chip"
                style={{ position: "relative" }}
              >
                <a href={openUrl} target="_blank" rel="noopener noreferrer">
                  <span>
                    <h5>
                      <i
                        className="fa-solid fa-arrow-up-right-from-square"
                        style={{ color: "#0068ff", marginRight: "6px" }}
                      />
                      {truncateTitle(title)}
                    </h5>
                  </span>
                </a>
                <i
                  className="fas fa-times"
                  onClick={() => handleRemove(link?.uuid)}
                ></i>
              </div>
            </Tooltip>
          );
        })}
    </>
  );
};

export default YoutubeLink;